import { get, head, isEmpty } from 'lodash/fp';
import React from 'react';

import { nextReduxWrapper } from '../../../../src/client/store/create-store';
import constants from '../../../../src/client/ahm-constants';
import fetchAllProductData from '../../../../src/client/models/product/fetch-all-product-data';
import GET_NO_GAP_DETAIL from '../../../../src/client/pages/no-gap/detail/queries/get-no-gap-detail';
import getCmsData from '../../../../src/client/cms/utils/get-cms-data';
import NoGapDetailPage, { NoGapDetailPageDataProps } from '../../../../src/client/pages/no-gap/detail';
import redirectTo404 from '../../../utils/redirect-to-404';
import setCacheControlHeader from '../../../utils/set-cache-control-header';

const { URLS } = constants;

const NoGapPage = ({ noGapDetailData }: NoGapDetailPageDataProps) => (
  <NoGapDetailPage noGapDetailData={noGapDetailData} />
);

export const getServerSideProps = nextReduxWrapper.getServerSideProps(
  (store) =>
    async ({ params, res, resolvedUrl }) => {
      setCacheControlHeader(res);

      const slug = get('slug', params);
      const isNoGapDentalPage = resolvedUrl === URLS.SALES.NO_GAP_DENTAL;

      const [cmsData] = await Promise.all([
        getCmsData(GET_NO_GAP_DETAIL, {
          variables: { identifier: slug },
        }),
        isNoGapDentalPage ? fetchAllProductData(store.getState(), store.dispatch) : null,
      ]);

      const noGapDetailData = head(get('allProductFeature', cmsData));

      // a no gap page not found for this url
      if (isEmpty(noGapDetailData)) {
        return redirectTo404();
      }

      return {
        props: {
          noGapDetailData,
        },
      };
    },
);

export default NoGapPage;
